export default "__VITE_ASSET__CyQA13yC__"